import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { CombinedFeedbackDataArray } from '@mopla/data-models';

import { MplButton } from '../../atoms/MplButton';

interface INonRatedContentProps {
	feedbackDataArray: CombinedFeedbackDataArray;
	onRatingClick: VoidFunction;
	isAbleToBeRated: boolean;
}

export const NonRatedContent: FC<INonRatedContentProps> = ({
	feedbackDataArray,
	onRatingClick,
	isAbleToBeRated,
}) => {
	const { t } = useTranslation('booking');

	return (
		<Stack gap={2}>
			<Stack gap={1}>
				{feedbackDataArray.map(({ driverCarDetails }, index) => (
					<Typography
						key={index}
						variant="body2"
						children={t('feedback.driver', {
							fullName: driverCarDetails.displayName,
							carId: driverCarDetails.carLicensePlate,
						})}
					/>
				))}
				<Typography variant="body2" color="neutral.60">
					{t('feedback.not_rated')}
				</Typography>
			</Stack>
			{isAbleToBeRated && (
				<MplButton fullWidth variant="outlined" onClick={onRatingClick}>
					{t('feedback.rate_button')}
				</MplButton>
			)}
		</Stack>
	);
};
